export default "__VITE_ASSET__BPRegxQ___"